import { Cell, RowPropGetter, TableRowProps } from "react-table";

import Collapse from "../../Collapse";
import Icon from "../../Icon";
import Modal from "react-modal";
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { getStyles } from "../utils";
import imagePlaceholder from "assets/images/placeholders/image.jpg";

const cellProps = (props: any, { cell }: any) => getStyles(props, cell.column.align, cell.column.maxWidth);

export interface TableRow {
	id: string;
	getRowProps: (propGetter?: RowPropGetter<object>) => TableRowProps;
	cells: Cell<object>[];
	expandable?: boolean;
	isExpanded?: boolean;
	onPress?: Function;
	renderExpanded?: React.ReactNode;
}

const cellKey = (cell: Cell<object>) => `table_cell_${cell.column.id}_${cell.row.id}_${JSON.stringify(cell.value)}`;

export class Row extends React.Component<TableRow, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			imageOver: false,
			imageOpened: false,
			pos: null
		};
	}

	onPress = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		const { onPress, ...props } = this.props;
		if (typeof onPress === "function") onPress(props, e);
	};

	handleImageHover(e: any, value: any) {
		const { imageOver } = this.state;
		if (imageOver) {
			this.setState({ imageOver: null });
		} else {
			this.setState({ imageOver: value });
		}
	}

	renderImagePopOver() {
		const { imageOver } = this.state;
		if (!imageOver) return null;

		return <img className="mouseOverImage" src={imageOver as any} alt="preview" />;
	}

	renderImageModal() {
		const { imageOpened } = this.state;

		return (
			<Modal
				isOpen={imageOpened}
				onRequestClose={() => {
					this.setState({ imageOpened: false });
				}}
				className="TableImageModalContent"
				overlayClassName="TableImageModalOverlay"
				// contentLabel="Modal"
			>
				<div className="Modal TableImageModal">
					<img src={imageOpened as any} alt="opened" className="TableImageModalImage" />
				</div>
			</Modal>
		);
	}

	renderCell = (cell: any) => {
		const { imageOver } = this.state;

		const align = cell.column.align || "left";

		return (
			<div {...(cell.getCellProps(cellProps) as {})} key={cellKey(cell)} className="TableData">
				{cell.column.id !== "actions" && typeof cell.value === "boolean" ? (
					cell.value ? (
						<Icon name="correct-symbol" />
					) : (
						<Icon name="close" />
					)
				) : (cell.column as any).type === "image" ? (
					<div
						className="hasImage"
						data-empty={!cell.value}
						onMouseOver={(e) => {
							if (!imageOver) this.handleImageHover(e, cell.value);
						}}
						onMouseLeave={(e) => {
							if (imageOver) this.handleImageHover(e, cell.value);
						}}
						onClick={() => {
							this.setState({ imageOpened: cell.value });
						}}
					>
						<img src={cell.value || imagePlaceholder} alt="table item" className="TableImageThumb" />
					</div>
				) : cell.column?.id === "row_actions" ? (
					cell.render("Cell")
				) : (
					<span className={`TableCellContent TableCellContent--${align}`}>
						{cell.render("Cell")}
					</span>
				)}
			</div>
		);
	};

	renderExpanded() {
		const { expandable, isExpanded, renderExpanded } = this.props;

		if (!expandable || typeof renderExpanded !== "function") return;

		return <Collapse expandedChildren={renderExpanded(this.props)} expanded={isExpanded} />;
	}

	render() {
		const { getRowProps, cells, onPress, isExpanded } = this.props;
		const hasOnPress = typeof onPress === "function";

		return (
			<React.Fragment>
				<div
					{...(getRowProps() as {})}
					className={`TableRow${hasOnPress ? " __clickable" : ""}${isExpanded ? " __expanded" : ""}`}
					onClick={this.onPress}
				>
					{cells.map(this.renderCell)}
				</div>
				{this.renderExpanded()}
				{this.renderImagePopOver()}
				{this.renderImageModal()}
			</React.Fragment>
		);
	}
}
